const styles = theme => ({
    chip: {
        minWidth: 60,
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            marginRight: theme.spacing(1),
            minWidth: 60,
        }
    }
});

export default styles;